export const accommodationDescription = {
  ACCOMMODATION_DESCRIPTION_COLLAPSE: 'accommodationDescription.collapse'
}
